import type { GameState, PlayerState } from '../shared/types';
import type { TurnTransitionFrame } from './turn-transition';

/** Actor presentation follows readyAt; the player's own meters never change owner. */
export function battleHudPlayers(state: GameState, displayed: readonly PlayerState[], selfId: string, turn: TurnTransitionFrame | null) {
  const actorId = turn?.playerId ?? state.turn.playerId;
  return {
    actorId,
    actor: displayed.find((player) => player.id === actorId) ?? state.players.find((player) => player.id === actorId),
    self: displayed.find((player) => player.id === selfId) ?? state.players.find((player) => player.id === selfId),
    number: turn?.number ?? state.turn.number,
  };
}

export function sameControlTurn(state: GameState | null, presented: TurnTransitionFrame | null): boolean {
  return state?.phase === 'playing' && presented?.key === `${state.round}:${state.turn.number}:${state.turn.playerId}`;
}
